import axios from 'axios'
import AuthService from './auth-header'
import { getMockCostModuleData } from '@/views/dashboard/reliance/mock/cost-module-data'

let API_URL = ''
if (process.env.NODE_ENV === "production") {
    API_URL = 'https://ats.sattvahuman.in/api/'
} else {
    API_URL = 'http://192.168.0.30:5000/api/'
}

class RelianceService {
    constructor() {
        // console.log('RelianceService initialized')
    }

    /**
     * Build axios query params for GET /reliance/dashboard (job-scope filters).
     * @param {string} clientName
     * @param {Object} filters - optional: positionType, function, driveName, positionSubmissionStartDate, positionSubmissionEndDate, startDate, endDate
     */
    buildDashboardQueryParams(clientName, filters = {}) {
        const params = { clientName: clientName || '' }
        if (!filters || typeof filters !== 'object') return params

        if (filters.positionType) params.positionType = filters.positionType
        if (filters.function) params.function = filters.function
        if (filters.driveName) params.driveName = filters.driveName
        if (filters.positionSubmissionStartDate) {
            params.positionSubmissionStartDate = filters.positionSubmissionStartDate
            if (filters.positionSubmissionEndDate) {
                params.positionSubmissionEndDate = filters.positionSubmissionEndDate
            }
        }
        if (filters.startDate) params.startDate = filters.startDate
        if (filters.endDate) params.endDate = filters.endDate

        return params
    }

    /**
     * Get Reliance Dashboard Data (KPI, positions, TAT, detailed overview, etc.)
     */
    async getDashboardData(clientName, filters = {}) {
        try {
            const params = this.buildDashboardQueryParams(clientName, filters)
            const response = await axios.get(API_URL + 'reliance/dashboard', {
                params,
                headers: AuthService.authHeader()
            })
            return response.data
        } catch (error) {
            console.error('Error fetching Reliance dashboard data:', error)
            const message = error.response?.data?.message || error.message
            return { status: 'ERROR', message, data: null }
        }
    }

    /**
     * Dropdown options for dashboard filters (functions, positions, drives).
     */
    async getDashboardFilterOptions(clientName) {
        try {
            const response = await axios.get(API_URL + 'reliance/dashboard/filter-options', {
                params: { clientName: clientName || '' },
                headers: AuthService.authHeader()
            })
            return response.data
        } catch (error) {
            console.error('Error fetching Reliance dashboard filter options:', error)
            return { status: 'ERROR', message: error.message, data: null }
        }
    }

    /**
     * Get Position-wise Data
     * @param {string} positionId - Optional position ID filter
     */
    async getPositionData(positionId = null) {
        try {
            let url = API_URL + 'reliance/positions'
            if (positionId) {
                url += `?positionId=${positionId}`
            }
            const response = await axios.get(url, {
                headers: AuthService.authHeader()
            })
            return response.data
        } catch (error) {
            console.error('Error fetching position data:', error)
            return { status: 'ERROR', message: error.message, data: [] }
        }
    }

    /**
     * Get Selection Funnel Data
     */
    async getSelectionFunnelData() {
        try {
            const response = await axios.get(API_URL + 'reliance/selection-funnel', {
                headers: AuthService.authHeader()
            })
            return response.data
        } catch (error) {
            console.error('Error fetching selection funnel data:', error)
            return { status: 'ERROR', message: error.message, data: [] }
        }
    }

    /**
     * Get Cost Module dashboard data (mock until GET /reliance/cost-dashboard is live).
     */
    async getCostDashboardData(clientName, filters = {}) {
        try {
            // TODO: replace mock with API when backend is ready
            // const params = this.buildDashboardQueryParams(clientName, filters)
            // const response = await axios.get(API_URL + 'reliance/cost-dashboard', {
            //     params,
            //     headers: AuthService.authHeader()
            // })
            // return response.data
            void clientName
            void filters
            return {
                status: 'SUCCESS',
                data: getMockCostModuleData(),
            }
        } catch (error) {
            console.error('Error fetching Reliance cost dashboard data:', error)
            const message = error.response?.data?.message || error.message
            return { status: 'ERROR', message, data: null }
        }
    }

    /**
     * Get Turn Around Time (TAT) Data
     */
    async getTATData() {
        try {
            const response = await axios.get(API_URL + 'reliance/tat-analysis', {
                headers: AuthService.authHeader()
            })
            return response.data
        } catch (error) {
            console.error('Error fetching TAT data:', error)
            return { status: 'ERROR', message: error.message, data: [] }
        }
    }
}

export default new RelianceService()
